import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-danger"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseRequiredFormGroup',
    props: {
        label: { default: '' },
        id: { default: null },
        isRequired: { type: Boolean, default: true }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_b_form_group = _resolveComponent("b-form-group");
            return (_openBlock(), _createBlock(_component_b_form_group, { id: _ctx.id }, {
                label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
                    (_ctx.isRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "* required information "))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ], undefined, true),
                _: 3
            }, 8, ["id"]));
        };
    }
});
